export type DistanceUnit = "metric" | "us";

const METERS_PER_MILE = 1_609.344;

export function formatDistance(
  meters: number,
  unit: DistanceUnit,
  options: { maximumFractionDigits?: number } = {},
): string {
  const maximumFractionDigits = options.maximumFractionDigits ?? 1;
  if (unit === "us") {
    return `${(meters / METERS_PER_MILE).toLocaleString(undefined, { maximumFractionDigits })} mi`;
  }
  return `${(meters / 1000).toLocaleString(undefined, { maximumFractionDigits })} km`;
}

export function distanceInputValue(meters: number, unit: DistanceUnit): string {
  const divisor = unit === "us" ? METERS_PER_MILE : 1000;
  const value = meters / divisor;
  return value.toFixed(Number.isInteger(value) ? 0 : 1);
}

export function metersFromDistanceInput(value: number, unit: DistanceUnit): number {
  return Math.round(value * (unit === "us" ? METERS_PER_MILE : 1000));
}

export function distanceUnitLabel(unit: DistanceUnit): string {
  return unit === "us" ? "miles" : "kilometres";
}
